/**
 * Expected keys to be returned as query
 * @param {Array}    ALLOWED_KEYS   List of keys for search query
 * @param {Object}   data           Object of key / values to build search query
 * @return {String}                 Query string to be used in api call
 */
const queryBuilder = (ALLOWED_KEYS, data) => {
  const buildQuery = ALLOWED_KEYS.filter((key) => data[key]).map(key => {
    if(Array.isArray(data[key])) {
      data[key].join(",");
    }
    return `${key}=${data[key]}`;
  });
  return buildQuery.join("&");
};

export {
  queryBuilder
};